import { Button } from "@/components/ui/button";
import Icons from "../../icons";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const FillApplications = ({ children, teamId, questions, code }: { children: React.ReactNode, teamId: string, questions: any, code: String }) => {
    const navigate = useNavigate();
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [onOpen, setOnOpen] = useState(false);
    const [answers, setAnswers] = useState<{ [key: string]: string }>({});
    const [error, setError] = useState('');
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, id: string) => {
        const { value } = e.target;
        setAnswers(prev => ({ ...prev, [id]: value }));

        const allFilled = questions.every((question: any) => answers[question.id]?.trim() !== "");
        setButtonDisabled(!allFilled);
    };

    const submitApplication = async () => {
        const response = await fetch(`__SITE_BASE__/api/v1/invites/${code}/join`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                answers: questions.map((question: any) => {
                    return {
                        questionId: question.id,
                        answer: answers[question.id]
                    };
                })
            })
        });
        const data = await response.json();
        if (data.message) return setError(data.message);
        navigate(`/me/applications`);
    }

    return (
        <Dialog open={onOpen} onOpenChange={onOpen => setOnOpen(onOpen)}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 max-h-96 overflow-auto" style={{ scrollbarWidth: "thin", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }}>
                <DialogHeader className="items-start justify-start">
                    <DialogTitle>
                        Fill out Application
                    </DialogTitle>
                    <DialogDescription />
                </DialogHeader>
                {error && <div className="text-red-500 text-sm">{error}</div>}
                <div className="flex flex-col gap-4 p-4">
                    {questions.map((question: any) => {
                        return (
                            <div key={question.id} className="flex flex-col gap-2">
                                <Label>{question.question}</Label>
                                {question.type === "textarea" && 
                                    <Input 
                                        className="rounded-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300" 
                                        type="textarea" 
                                        onChange={(e) => handleInputChange(e, question.id)} 
                                    />}
                                {question.type === "text" && 
                                    <Input 
                                        className="rounded-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300" 
                                        onChange={(e) => handleInputChange(e, question.id)} 
                                    />}
                            </div>
                        );
                    })}
                    <div className="sticky bottom-0 flex justify-center">
                        <Button disabled={buttonDisabled} className="bg-brand-green px-5 py-2 w-full rounded-lg text-white font-semibold hover:bg-green-500" onClick={submitApplication}>Submit Application</Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
